export default "__VITE_ASSET__e0b81c06__"